import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  role: 'E-commerce Owner',
  content: 'Switching to Fox Line Hosting was the best decision for my online store. The NVMe speeds are incredible, and my page load times dropped by half.',
  avatar: 'https://i.pravatar.cc/150?img=47'
}, {
  name: 'David Chen',
  role: 'Lead Developer',
  content: 'Their dedicated servers provide the raw performance we need for our SaaS application. The 24/7 support team is actually knowledgeable and helpful.',
  avatar: 'https://i.pravatar.cc/150?img=11'
}, {
  name: 'Emily Rodriguez',
  role: 'Freelance Designer',
  content: "I host all my clients' websites here. The control panel is intuitive, and the uptime has been flawless. Highly recommend the Professional plan.",
  avatar: 'https://i.pravatar.cc/150?img=5'
}];
export function Testimonials() {
  return <section className="py-24 bg-slate-950 overflow-hidden" data-id="element-1394">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1395">
        <div className="text-center mb-16" data-id="element-1396">
          <h2 className="text-fox-500 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-1397">
            Testimonials
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-1398">
            Trusted by thousands
          </h3>
        </div>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-1399">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel p-8 rounded-2xl max-w-md w-full flex-1 min-w-[300px]" data-id="element-1400">
              <div className="flex gap-1 mb-6" data-id="element-1401">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-amber-500 text-amber-500" data-id="element-1402" />)}
              </div>
              <p className="text-slate-300 mb-8 text-lg italic" data-id="element-1403">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4" data-id="element-1404">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full border-2 border-slate-700" data-id="element-1405" />
                <div data-id="element-1406">
                  <h5 className="text-white font-bold" data-id="element-1407">{testimonial.name}</h5>
                  <span className="text-slate-400 text-sm" data-id="element-1408">
                    {testimonial.role}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}